<div class="fk-w-full">
  <label [for]="id" class="fk-flex fk-items-center fk-cursor-pointer">
    <!-- toggle -->
    <div class="fk-relative">
      <!-- input -->
      <input
        type="checkbox"
        [id]="id"
        class="sr-only"
        [(ngModel)]="value"
        (change)="onEmitValue()"
        [disabled]="isDisabled"
      />
      <!-- line -->
      <div
        class="fk-block fk-rounded-full fk-transition-transform fk-duration-300"
        [ngClass]="{
          'fk-w-14 fk-h-8': size == 'lg',
          'fk-w-10 fk-h-6': size == 'sm',
          'fk-w-12 fk-h-7': size == 'md'
        }"
        [class]="value ? bgColorClass : 'fk-bg-gray-200'"
      ></div>

      <!-- dot -->
      <div
        class="dot fk-absolute fk-top-1 fk-bg-white fk-w-4 fk-h-4 fk-rounded-full fk-transition-transform fk-duration-300"
        [class]="
          value && isLtr
            ? 'fk-translate-x-120'
            : !value && isLtr
            ? 'fk-translate-x-25'
            : value && !isLtr
            ? '-fk-translate-x-122'
            : !value && !isLtr
            ? '-fk-translate-x-20'
            : ''
        "
        [ngClass]="{
          'fk-w-6 fk-h-6': size == 'lg',
          'fk-w-4 fk-h-4': size == 'sm',
          'fk-w-5 fk-h-5': size == 'md'
        }"
      ></div>
    </div>

    <!-- label -->
    <div
      class="fk-ml-3 fk-text-gray-700 fk-font-medium fk-mx-2 fk-mt-1"
      [class]="size == 'sm' ? 'fk-text-sm' : 'fk-text-base'"
      [ngClass]="{
        'fk-text-gray-300': isDisabled,
        'fk-text-gray-700': !isDisabled
      }"
    >
      {{ label | translate }}
    </div>
    <ng-content select="[label]"></ng-content>
  </label>
</div>
